module.exports = __webpack_public_path__ + "static/img/logo.a53395d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 15